module.exports = __webpack_public_path__ + "static/media/plain-ball-3.476272c2.gif";